import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    document.addEventListener("trix-initialize", this.configureTrixButtons);
  }

  disconnect() {
    document.removeEventListener("trix-initialize", this.configureTrixButtons);
  }

  configureTrixButtons = (event) => {
    const trixEditor = event.target;
    const context = trixEditor.dataset.trixContext;
    const toolbar = trixEditor.toolbarElement;

    // Add custom buttons and manage attachments if the context is 'articles'
    if (context === "articles") {
      this.addCustomButtons(toolbar, trixEditor);
      this.manageAttachments(toolbar, true);
    } else {
      this.manageAttachments(toolbar, false);
    }

    this.removeHeadingOneButton(toolbar);
  };

  addCustomButtons(toolbar, trixEditor) {
    this.addToolbarButton(toolbar, "heading", "H2", "Heading 2");
    this.addToolbarButton(toolbar, "subHeading", "H3", "Heading 3");
    this.addAdButton(toolbar, trixEditor);
  }

  addToolbarButton(toolbar, attribute, text, title) {
    if (!toolbar.querySelector(`[data-trix-attribute="${attribute}"]`)) {
      const buttonHTML = `<button type="button" class="trix-button" data-trix-attribute="${attribute}" title="${title}">${text}</button>`;
      toolbar
        .querySelector(".trix-button-group--block-tools")
        .insertAdjacentHTML("beforeend", buttonHTML);
    }
  }

  addAdButton(toolbar, trixEditor) {
    if (!toolbar.querySelector('[data-ad-button="true"]')) {
      const buttonHTML = `<button type="button" class="trix-button" data-ad-button="true" title="Insert Ad">Ad</button>`;
      toolbar
        .querySelector(".trix-button-group--block-tools")
        .insertAdjacentHTML("beforeend", buttonHTML);

      // Add click handler to the newly created button
      const adButton = toolbar.querySelector('[data-ad-button="true"]');
      adButton.addEventListener("click", (e) => {
        e.preventDefault();
        trixEditor.editor.insertString("\n[AD:adsense_trix]\n");
      });
    }
  }

  manageAttachments(toolbar, show) {
    const attachmentGroup = toolbar.querySelector(".trix-button-group--file-tools");
    if (attachmentGroup) {
      attachmentGroup.style.display = show ? "" : "none";
    }
  }

  removeHeadingOneButton(toolbar) {
    const headingOneButton = toolbar.querySelector('[data-trix-attribute="heading1"]');
    if (headingOneButton) {
      headingOneButton.parentNode.removeChild(headingOneButton);
    }
  }
}